import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { useIdle } from '@mantine/hooks';

import { useTenantInfoData } from '../../api/portalGateway/tenantInfo';
import { useStore } from '../../store';

export function InactivityObserver() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logoutSession = useStore((state) => state.logoutSession);

  const { data: tenantInfo } = useTenantInfoData();

  const idle = useIdle(tenantInfo.inactivityTimeout, { initialState: false });

  const logout = useCallback(async () => {
    await logoutSession({ persistCurrentPage: true });
    navigate('/login', {
      state: { logoutReason: t('app.inactivityLogout') },
    });
  }, [logoutSession, navigate, t]);

  useEffect(() => {
    if (idle === true) {
      logout();
    }
  }, [idle, logout]);

  return <Outlet />;
}
